/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit'
import * as API from '../../api'

export const getSuggestedUserList = createAsyncThunk(
  'suggestedUserList/getSuggestedAccountUsers',
  async (accountId: number) => {
    const response = await API.getSuggestedUserList(accountId)
    return response.data
  }
)
